import Modal from 'react-modal';
import styled from 'styled-components';

export const Container = styled(Modal)`
  border: solid 2px;
  border-color: ${({ theme }) => theme.colors.tertiary_500};
  z-index: 1;
`;
